import { staticColors } from '../../../../../const/colors/staticColors';
const SELECTED_DAY_BACKGROUND_COLOR = staticColors.calendarBackgroundSelectDate;
const DEFAULT_BACKGROUND_COLOR = 'transparent';
export const getDayBackgroundColor = ({ isSelectedDay, }) => {
    if (isSelectedDay) {
        return SELECTED_DAY_BACKGROUND_COLOR;
    }
    return DEFAULT_BACKGROUND_COLOR;
};
